import { tokens } from '@news-mono/design-tokens'
import {
    BreakpointState,
    metrics,
    ThemeConfig,
    TheNightlyThemeConfig,
} from '../../../__styling'

export type LeadCardTheme<T extends ThemeConfig> = {
    topicByline: {
        textColor: string
    }
    teaser: {
        textColor: string
    }
    link: {
        textColor: string
    }
    breakpointState: BreakpointState<
        T['breakpoints'],
        {
            padding: string
        }
    >
}

export const theNightlyLeadCardTheme: LeadCardTheme<TheNightlyThemeConfig> = {
    topicByline: {
        textColor: tokens.thenightly.colors.palette.grey[60],
    },
    teaser: {
        textColor: tokens.thenightly.colors.palette.grey[70],
    },
    link: {
        textColor: tokens.thenightly.colors.palette.grey[70],
    },
    breakpointState: {
        default: {
            padding: `0 ${metrics.thenightly.margins.m2l}px`,
        },
        sm: {
            padding: '0px',
        },
    },
}
